import React, { useState, useEffect, Component } from 'react'
import { Button, Col, Container, ListGroup, Row, Badge, Modal, Form, FormGroup, FormLabel, Card, Table, OverlayTrigger, Tooltip, ProgressBar, Alert } from "react-bootstrap";
import { Navigate} from 'react-router-dom';
import CurrencyInput,{ formatValue } from 'react-currency-input-field';
import {connect} from 'react-redux';
import {getUser,getAssets, createAsset, deleteAsset, createTransaction, updateAsset, getBook, getCategories, updateBookHistory, getTransactions, updateAssets} from '../context/actions/index'
import { 
  FaChartLine,
  FaBuilding,
  FaCreditCard,
  FaInfoCircle,
  FaEdit,
  FaSave,
  FaTimes,
  FaSyncAlt,
  FaExclamationTriangle,
  FaPlus,
  FaCalculator,
  FaChartBar,
  FaBalanceScale,
  FaMoneyBillWave,
  FaShieldAlt,
  FaTrash
} from 'react-icons/fa';
import { FiTrendingUp,FiTrendingDown  } from "react-icons/fi";
import ModernConfirmModal from './ModernConfirmModal';

class ReviewBook extends Component{
    handleClose = () => this.setState({data:'', show:false, edit:false, showCreateModal:false});
    handleShow = () => this.setState({show:true});
    
    constructor(props){
        super(props);
		this.state ={
			show: false,
            showCreateModal: false,
            data:'',
            dataUpdate:[],
            edit:false,
            done:false,
            saving: false,
            activeTab: 'neraca', // 'neraca', 'analisa'
            showDeleteConfirm: false,
            deleteLoading: false, 
		}
    }
    
    componentDidMount(){
        this.init()
    }

    init = async() =>{
        let bookId = JSON.parse(localStorage.bookId);
        let data = JSON.parse(localStorage["user-data"]);
        this.props.getUser(data.user_id)
        const book = await this.props.getBook(bookId)
        this.props.getAssets(bookId)
        this.props.getCategories(bookId)
        const active_month = new Date(this.props.books["active_month"])
        this.props.getTransactions(bookId, active_month.getUTCMonth() + 1, active_month.getFullYear());
    }

    // Fungsi untuk menghitung total asset dengan menambahkan transaksi (sama seperti di assets.js)
    calculateAssetWithTransactions = (assets, transactions) => {
        return assets.map(asset => {
            // Filter transaksi yang terkait dengan asset ini
            const assetTransactions = transactions.filter(transaction => 
                transaction.asset_id === asset.asset_id
            );

            // Hitung total dari transaksi
            const transactionTotal = assetTransactions.reduce((total, transaction) => {
                let amount = parseInt(transaction.amount) || 0;
                return total + amount;
            }, 0);

            // Jumlahkan dengan amount awal asset
            const initialAmount = parseInt(asset.amount) || 0;
            const finalAmount = initialAmount + transactionTotal;

            return {
                ...asset,
                initialAmount: initialAmount,
                transactionTotal: transactionTotal,
                finalAmount: finalAmount,
                transactionCount: assetTransactions.length
            };
        });
    };
    
    calculateTotal = (items) => {
        if (!items) return 0;
        return items.reduce((total, item) => total + (parseInt(item.finalAmount || item.amount) || 0), 0);
    };
    
    getUpdate = (assetId) =>{
        const index = this.state.dataUpdate.findIndex(x => x.assetId == assetId)
        if(index !== -1){
            const change = this.state.dataUpdate[index].tAmount;
            const variant = change >= 0 ? "success" : "danger";
            const amount = formatValue({
                value: Math.abs(change).toString(),
                intlConfig: { locale: 'id-ID', currency: 'IDR' },
            });
            
            return (
                <Badge bg={variant} className="ms-2">
                    {change >= 0 ? '+' : '-'} {amount}
                </Badge>
            ) 
        }
    }
    
    // Analisa Keuangan
    calculateFinancialRatios = () => {
        // Gunakan assets dengan transaksi untuk perhitungan
        const assetsWithTransactions = this.calculateAssetWithTransactions(
            this.props.assets || [], 
            this.props.transactions || []
        );
        
        const asetLancar = assetsWithTransactions.filter(asset => (asset.type ==='1' && asset.category ==='1'));
        const kewajibanPendek = assetsWithTransactions.filter(asset => (asset.type ==='2' && asset.category ==='4'));
        const totalAset = assetsWithTransactions.filter(asset => asset.type ==='1');
        const totalKewajiban = assetsWithTransactions.filter(asset => asset.type ==='2');
        
        const totalAsetLancar = this.calculateTotal(asetLancar);
        const totalKewajibanPendek = this.calculateTotal(kewajibanPendek);
        const totalAllAset = this.calculateTotal(totalAset);
        const totalAllKewajiban = this.calculateTotal(totalKewajiban);
        const totalEkuitas = totalAllAset - totalAllKewajiban;
        
        // Rasio Likuiditas
        const currentRatio = totalKewajibanPendek > 0 ? (totalAsetLancar / totalKewajibanPendek) : 0;
        
        // Rasio Solvabilitas
        const debtToAssetRatio = totalAllAset > 0 ? (totalAllKewajiban / totalAllAset) : 0;
        
        // Rasio Profitabilitas (asumsi)
        const roa = totalAllAset > 0 ? (totalEkuitas / totalAllAset) * 100 : 0;
        
        return {
            currentRatio: currentRatio.toFixed(2),
            debtToAssetRatio: (debtToAssetRatio * 100).toFixed(1),
            roa: roa.toFixed(1),
            totalEkuitas,
            totalAllAset,
            totalAllKewajiban
        };
    }

    FinancialAnalysis = () => {
        const ratios = this.calculateFinancialRatios();
        
        const getRatioVariant = (value, type) => {
            switch(type) {
                case 'current':
                    return value >= 1.5 ? 'success' : value >= 1 ? 'warning' : value == 0? 'success' : 'danger';
                case 'debt':
                    return value <= 50 ? 'success' : value <= 70 ? 'warning' : 'danger';
                case 'roa':
                    return value >= 10 ? 'success' : value >= 5 ? 'warning' : 'danger';
                default:
                    return 'secondary';
            }
        };

        const getRatioIcon = (value, type) => {
            switch(type) {
                case 'current':
                    return value >= 1.5 ? <FiTrendingUp className="text-success" /> : 
                           value >= 1 ? <FiTrendingUp className="text-warning" /> : 
                           value == 0 ? <FiTrendingUp className="text-success" /> : <FiTrendingDown className="text-danger" />;
                case 'debt':
                    return value <= 50 ? <FiTrendingDown className="text-success" /> : 
                           value <= 70 ? <FiTrendingUp className="text-warning" /> : <FiTrendingUp className="text-danger" />;
                case 'roa':
                    return value >= 10 ? <FiTrendingUp className="text-success" /> : 
                           value >= 5 ? <FiTrendingUp className="text-warning" /> : <FiTrendingDown className="text-danger" />;
                default:
                    return <FaChartBar />;
            }
        };

        return (
            <Row>
                <Col lg={4} className="mb-4">
                    <Card className="h-100 border-0 shadow-sm">
                        <Card.Body className="text-center">
                            <div className="bg-primary bg-opacity-10 rounded-circle d-inline-flex p-3 mb-3">
                                <FaMoneyBillWave className="text-primary" size={24} />
                            </div>
                            <h5 className="card-title">Rasio Likuiditas</h5>
                            <h2 className={`text-${getRatioVariant(ratios.currentRatio, 'current')}`}>
                                {ratios.currentRatio}x
                            </h2>
                            <div className="mb-3">
                                {getRatioIcon(ratios.currentRatio, 'current')}
                            </div>
                            <ProgressBar 
                                variant={getRatioVariant(ratios.currentRatio, 'current')}
                                now={Math.min(ratios.currentRatio * 20, 100)} 
                                className="mb-2"
                            />
                            <small className="text-muted">
                                {ratios.currentRatio >= 1.5 ? 'Sangat Baik' : 
                                 ratios.currentRatio >= 1 ? 'Cukup' : 
                                 ratios.currentRatio == 0 ? 'Belum Cukup Data' : 
                                 'Perhatian'}
                            </small>
                        </Card.Body>
                    </Card>
                </Col>

                <Col lg={4} className="mb-4">
                    <Card className="h-100 border-0 shadow-sm">
                        <Card.Body className="text-center">
                            <div className="bg-danger bg-opacity-10 rounded-circle d-inline-flex p-3 mb-3">
                                <FaShieldAlt className="text-danger" size={24} />
                            </div>
                            <h5 className="card-title">Rasio Hutang</h5>
                            <h2 className={`text-${getRatioVariant(ratios.debtToAssetRatio, 'debt')}`}>
                                {ratios.debtToAssetRatio}%
                            </h2>
                            <div className="mb-3">
                                {getRatioIcon(ratios.debtToAssetRatio, 'debt')}
                            </div>
                            <ProgressBar 
                                variant={getRatioVariant(ratios.debtToAssetRatio, 'debt')}
                                now={ratios.debtToAssetRatio} 
                                className="mb-2"
                            />
                            <small className="text-muted">
                                {ratios.debtToAssetRatio <= 50 ? 'Aman' : 
                                 ratios.debtToAssetRatio <= 70 ? 'Waspada' : 'Bahaya'}
                            </small>
                        </Card.Body>
                    </Card>
                </Col>

                <Col lg={4} className="mb-4">
                    <Card className="h-100 border-0 shadow-sm">
                        <Card.Body className="text-center">
                            <div className="bg-success bg-opacity-10 rounded-circle d-inline-flex p-3 mb-3">
                                <FaChartLine className="text-success" size={24} />
                            </div>
                            <h5 className="card-title">ROA</h5>
                            <h2 className={`text-${getRatioVariant(ratios.roa, 'roa')}`}>
                                {ratios.roa}%
                            </h2>
                            <div className="mb-3">
                                {getRatioIcon(ratios.roa, 'roa')}
                            </div>
                            <ProgressBar 
                                variant={getRatioVariant(ratios.roa, 'roa')}
                                now={Math.min(ratios.roa * 2, 100)} 
                                className="mb-2"
                            />
                            <small className="text-muted">
                                {ratios.roa >= 10 ? 'Efisien' : 
                                 ratios.roa >= 5 ? 'Cukup' : 'Perlu Perbaikan'}
                            </small>
                        </Card.Body>
                    </Card>
                </Col>

                {/* Summary Keuangan */}
                <Col md={12}>
                    <Card className="border-0 shadow-sm">
                        <Card.Header className="bg-light">
                            <h6 className="mb-0 d-flex align-items-center">
                                <FaCalculator className="me-2 text-primary" />
                                Ringkasan Keuangan
                            </h6>
                        </Card.Header>
                        <Card.Body>
                            <Row>
                                <Col md={4} className="text-center border-end">
                                    <h4 className="text-success">
                                        {formatValue({
                                            value: ratios.totalEkuitas.toString(),
                                            intlConfig: { locale: 'id-ID', currency: 'IDR' },
                                        })}
                                    </h4>
                                    <small className="text-muted">Total Ekuitas</small>
                                </Col>
                                <Col md={4} className="text-center border-end">
                                    <h4 className="text-primary">
                                        {formatValue({
                                            value: ratios.totalAllAset.toString(),
                                            intlConfig: { locale: 'id-ID', currency: 'IDR' },
                                        })}
                                    </h4>
                                    <small className="text-muted">Total Aset</small>
                                </Col>
                                <Col md={4} className="text-center">
                                    <h4 className="text-danger">
                                        {formatValue({
                                            value: ratios.totalAllKewajiban.toString(),
                                            intlConfig: { locale: 'id-ID', currency: 'IDR' },
                                        })}
                                    </h4>
                                    <small className="text-muted">Total Kewajiban</small>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        );
    }

    BalanceSheet = () => {
        try{
        // Gunakan assets dengan transaksi untuk neraca
        const assetsWithTransactions = this.calculateAssetWithTransactions(
            this.props.assets || [], 
            this.props.transactions || []
        );
        
        const asetLancar = assetsWithTransactions.filter(asset => (asset.type ==='1' && asset.category ==='1'));
        const asetTetap = assetsWithTransactions.filter(asset => (asset.type ==='1' && asset.category ==='2'));
        const asetInvestasi = assetsWithTransactions.filter(asset => (asset.type ==='1' && asset.category ==='3'));
        const kewajibanPendek = assetsWithTransactions.filter(asset => (asset.type ==='2' && asset.category ==='4'));
        const kewajibanPanjang = assetsWithTransactions.filter(asset => (asset.type ==='2' && asset.category ==='5'));

        const totalAsetLancar = this.calculateTotal(asetLancar);
        const totalAsetTetap = this.calculateTotal(asetTetap);
        const totalAsetInvestasi = this.calculateTotal(asetInvestasi);
        const totalAset = totalAsetLancar + totalAsetTetap + totalAsetInvestasi;

        const totalKewajibanPendek = this.calculateTotal(kewajibanPendek);
        const totalKewajibanPanjang = this.calculateTotal(kewajibanPanjang);
        const totalKewajiban = totalKewajibanPendek + totalKewajibanPanjang;
        const totalEkuitas = totalAset - totalKewajiban;

        // Fungsi untuk render row asset dengan detail transaksi
        const renderAssetRow = (asset) => {
            const hasTransactions = asset.transactionCount > 0;
            const amountDifference = asset.finalAmount - asset.initialAmount;
            
            return (
                <ListGroup.Item 
                    key={asset.asset_id}
                    className="d-flex justify-content-between align-items-center py-3 border-0 hover-item"
                    style={{cursor: 'pointer'}}
                    onClick={() => this.editData(asset)}
                >
                    <div className="d-flex align-items-center">
                        <div className="bg-primary bg-opacity-10 rounded p-2 me-3">
                            <FaMoneyBillWave className="text-primary" size={16} />
                        </div>
                        <div>
                            <div className="fw-semibold">{asset.name}</div>
                            {hasTransactions && (
                                <small className="text-muted">
                                    {asset.transactionCount} transaksi • 
                                    Saldo awal: {formatValue({
                                        value: asset.initialAmount.toString(),
                                        intlConfig: { locale: 'id-ID', currency: 'IDR' },
                                    })}
                                </small>
                            )}
                        </div>
                    </div>
                    <div className="text-end">
                        <div className="fw-bold text-primary">
                            {formatValue({
                                value: asset.finalAmount.toString(),
                                intlConfig: { locale: 'id-ID', currency: 'IDR' },
                            })}
                        </div>
                        {hasTransactions && amountDifference !== 0 && (
                            <small className={amountDifference > 0 ? 'text-success' : 'text-danger'}>
                                {amountDifference > 0 ? '+' : ''}
                                {formatValue({
                                    value: Math.abs(amountDifference).toString(),
                                    intlConfig: { locale: 'id-ID', currency: 'IDR' },
                                })}
                            </small>
                        )}
                        {this.getUpdate(asset.asset_id)}
                    </div>
                </ListGroup.Item>
            );
        };

        return (
            <Row>
                <Col md={6} className="mb-4">
                    <Card className="h-100 border-0 shadow-sm">
                        <Card.Header className="bg-primary text-white d-flex justify-content-between align-items-center">
                            <h6 className="mb-0">
                                <FaBuilding className="me-2" />
                                ASET
                            </h6>
                            <Badge bg="light" text="dark">
                                {formatValue({
                                    value: totalAset.toString(),
                                    intlConfig: { locale: 'id-ID', currency: 'IDR' },
                                })}
                            </Badge>
                        </Card.Header>
                        <Card.Body>
                            {/* Aset Lancar */}
                            <div className="mb-4">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h6 className="text-primary mb-0">Aset Lancar</h6>
                                    <Badge bg="primary" className="fs-6">
                                        {formatValue({
                                            value: totalAsetLancar.toString(),
                                            intlConfig: { locale: 'id-ID', currency: 'IDR' },
                                        })}
                                    </Badge>
                                </div>
                                <ListGroup variant="flush">
                                    {asetLancar.map(asset => renderAssetRow(asset))}
                                </ListGroup>
                            </div>

                            {/* Aset Guna */}
                            <div className="mb-4">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h6 className="text-primary mb-0">Aset Guna</h6>
                                    <Badge bg="primary" className="fs-6">
                                        {formatValue({
                                            value: totalAsetTetap.toString(),
                                            intlConfig: { locale: 'id-ID', currency: 'IDR' },
                                        })}
                                    </Badge>
                                </div>
                                <ListGroup variant="flush">
                                    {asetTetap.map(asset => renderAssetRow(asset))}
                                </ListGroup>
                            </div>

                            {/* Aset Investasi */}
                            <div className="mb-4">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h6 className="text-primary mb-0">Aset Investasi</h6>
                                    <Badge bg="primary" className="fs-6">
                                        {formatValue({
                                            value: totalAsetInvestasi.toString(),
                                            intlConfig: { locale: 'id-ID', currency: 'IDR' },
                                        })}
                                    </Badge>
                                </div>
                                <ListGroup variant="flush">
                                    {asetInvestasi.map(asset => renderAssetRow(asset))}
                                </ListGroup>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                <Col md={6} className="mb-4">
                    <Card className="h-100 border-0 shadow-sm">
                        <Card.Header className="bg-danger text-white d-flex justify-content-between align-items-center">
                            <h6 className="mb-0">
                                <FaCreditCard className="me-2" />
                                KEWAJIBAN & EKUITAS
                            </h6>
                        </Card.Header>
                        <Card.Body>
                            {/* Kewajiban Pendek */}
                            <div className="mb-4">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h6 className="text-danger mb-0">Kewajiban Jangka Pendek</h6>
                                    <Badge bg="danger" className="fs-6">
                                        {formatValue({
                                            value: totalKewajibanPendek.toString(),
                                            intlConfig: { locale: 'id-ID', currency: 'IDR' },
                                        })}
                                    </Badge>
                                </div>
                                <ListGroup variant="flush">
                                    {kewajibanPendek.map(asset => renderAssetRow(asset))}
                                </ListGroup>
                            </div>

                            {/* Kewajiban Panjang */}
                            <div className="mb-4">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h6 className="text-danger mb-0">Kewajiban Jangka Panjang</h6>
                                    <Badge bg="danger" className="fs-6">
                                        {formatValue({
                                            value: totalKewajibanPanjang.toString(),
                                            intlConfig: { locale: 'id-ID', currency: 'IDR' },
                                        })}
                                    </Badge>
                                </div>
                                <ListGroup variant="flush">
                                    {kewajibanPanjang.map(asset => renderAssetRow(asset))}
                                </ListGroup>
                            </div>

                            {/* Ekuitas */}
                            <div className="mb-4">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h6 className="text-success mb-0">Ekuitas</h6>
                                    <Badge bg="success" className="fs-6">
                                        {formatValue({
                                            value: totalEkuitas.toString(),
                                            intlConfig: { locale: 'id-ID', currency: 'IDR' },
                                        })}
                                    </Badge>
                                </div>
                                <ListGroup variant="flush">
                                    <ListGroup.Item className="d-flex justify-content-between align-items-center py-3 border-0 bg-success bg-opacity-10">
                                        <div className="d-flex align-items-center">
                                            <div className="bg-success bg-opacity-25 rounded p-2 me-3">
                                                <FaBalanceScale className="text-success" size={16} />
                                            </div>
                                            <div className="fw-semibold">Modal Pemilik</div>
                                        </div>
                                        <div className="fw-bold text-success">
                                            {formatValue({
                                                value: totalEkuitas.toString(),
                                                intlConfig: { locale: 'id-ID', currency: 'IDR' },
                                            })}
                                        </div>
                                    </ListGroup.Item>
                                </ListGroup>
                            </div>

                            {/* Total Kewajiban & Ekuitas */}
                            <div className="border-top pt-3">
                                <div className="d-flex justify-content-between align-items-center">
                                    <h6 className="mb-0">Total Kewajiban & Ekuitas</h6>
                                    <h5 className="mb-0 text-dark">
                                        {formatValue({
                                            value: (totalKewajiban + totalEkuitas).toString(),
                                            intlConfig: { locale: 'id-ID', currency: 'IDR' },
                                        })}
                                    </h5>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        );
        }
        catch(e){
            console.log(e)
            return <div className="alert alert-danger">Error loading assets data</div>;
        }
    }

    updateAssetTemp = (data) =>{
        // Hanya simpan perubahan untuk aset lancar (category === '1')
        //if (data.category === '1') {
            var temp = [...this.state.dataUpdate];
            var index = temp.findIndex(x => x.assetId == data.assetId)
            
            if (index !== -1){
                temp[index] = {...temp[index], ...data};
            }
            else{
                temp.push(data);
            }
            this.setState({dataUpdate: temp});
        //}
    }
    getTransactionDate(){
        const [year, month] = this.props.books["active_month"].split('-').map(Number);
        return new Date(year, month, 0);
    }

    saveAllTransactions = async () => {
        const { dataUpdate } = this.state;
        console.log("savealltransaction")
        if (dataUpdate.length === 0) {
            return true;
        }

        this.setState({ saving: true });

        try {
            // Hanya buat transaksi untuk aset lancar
            const currentAssetUpdates = dataUpdate.filter(change => change.category === '1');
            
            const transactionPromises = currentAssetUpdates.map(change => 
                
                this.props.createTransaction({
                    assetId: change.assetId,
                    bookId: change.bookId,
                    desc: "Penyesuaian tutup buku - " + change.name,
                    categoryId: 0,
                    amount: change.tAmount,
                    transactionDate: this.getTransactionDate(),
                    edit: false
                })
                    
            );

            await Promise.all(transactionPromises)
                this.updateNonAsetLancar()
                //this.setState({ dataUpdate: [] });
                return true;
            
            
            
        } catch (error) {
            console.error("Error saving transactions:", error);
            return false;
        } finally {
            this.setState({ saving: false });
        }
    }

    updateNonAsetLancar = async () => {
        const { dataUpdate } = this.state;
        
        if (dataUpdate.length === 0) {
            return true;
        }

        this.setState({ saving: true });

        try {
            // Hanya buat transaksi untuk aset lancar
            const currentAssetUpdates = dataUpdate.filter(change => change.category != '1');
            
            const AsetPromises = currentAssetUpdates.map(change => {
                console.log(change)
                
                this.props.updateAsset({
                    assetId: change.assetId,
                    amount: change.amount,
                })
                
            }
            );
            console.log("here")
            await Promise.all(AsetPromises);
            this.setState({ dataUpdate: [] });
            return true;
        } catch (error) {
            console.error("Error saving asset:", error);
            return false;
        } finally {
            this.setState({ saving: false });
        }
    }

    // Fungsi untuk mengupdate bookhistory dengan data final setelah transaksi
    updateBookHistoryWithFinalData = async () => {
        try {
            // Hitung assets dengan transaksi untuk mendapatkan nilai final
            console.log(this.props.transactions)
            const assetsWithTransactions = this.calculateAssetWithTransactions(
                this.props.assets || [], 
                this.props.transactions || []
            );
            console.log(assetsWithTransactions)
                var d = new Date(),
                month = '' + (d.getMonth() + 1),
                year = d.getFullYear();
                const bookId = JSON.parse(localStorage.bookId)

                const assetLancar = assetsWithTransactions.filter(a => a.type === '1')

            // Siapkan data untuk bookhistory
            const bookHistoryData = {
                history: assetsWithTransactions.map(asset => ({
                    item_id: asset.asset_id,
                    book_id: bookId,
                    item_category: "1",
                    item_amount: asset.finalAmount, // Gunakan finalAmount yang sudah termasuk transaksi
                    month: month,
                    year: year
                })),
                assetsAmount: assetLancar.map(asset => ({
                    asset_id: asset.asset_id,
                    amount: asset.finalAmount, // Gunakan finalAmount yang sudah termasuk transaksi
                })),
                total_assets: this.calculateTotal(assetsWithTransactions.filter(a => a.type === '1')),
                total_liabilities: this.calculateTotal(assetsWithTransactions.filter(a => a.type === '2')),
                total_equity: this.calculateTotal(assetsWithTransactions.filter(a => a.type === '1')) - this.calculateTotal(assetsWithTransactions.filter(a => a.type === '2')),
                period: new Date()
            };
            console.log(bookHistoryData)
            console.log(assetLancar)

            // Panggil action untuk update bookhistory dengan data final
            
            const result = await this.props.updateBookHistory(bookHistoryData);
            console.log(result)
            if(result){
                await this.props.updateAssets(bookHistoryData)
                
            }
            

            //update data akun bulan baru
            



            return result;
            
        } catch (error) {
            console.error("Error updating book history:", error);
            throw error;
        }
    }

    confirmClose = async () => {
        if(window.confirm("Yakin semua data sudah sesuai untuk masuk ke bulan baru? Data final setelah transaksi akan disimpan ke history.") === true){
            try {
                const transactionsSaved = await this.saveAllTransactions();
                
                
                if (transactionsSaved) {
                    // Update bookhistory dengan data final setelah transaksi
                    console.log(this.props.transactions)
                    const historyUpdated = await this.updateBookHistoryWithFinalData();
                    
                    if(historyUpdated){
                        this.setState({done: true});
                    } else {
                        alert("Gagal menyimpan history buku. Silakan coba lagi.");
                    }
                } else {
                    alert("Gagal menyimpan transaksi. Silakan coba lagi.");
                }
            } catch (error) {
                console.error("Error during book closing:", error);
                alert("Terjadi kesalahan saat memproses tutup buku.");
            }
        }
    }

    EditAssetModal = () =>{
        return(
            <Modal show={this.state.show} onHide={this.handleClose} centered size="lg">
                <Modal.Header closeButton className="bg-gradient-primary text-white">
                    <Modal.Title className="d-flex align-items-center">
                        <FaEdit className="me-2" />
                        Edit Aset
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <EditAssetForm 
                        handleClose={this.handleClose} 
                        data={this.state.data} 
                        edit={this.state.edit} 
                        updateAsset={this.updateAssetTemp}
                        deleteAsset={this.props.deleteAsset}
                        getAssets={this.props.getAssets}
                    />
                </Modal.Body>
            </Modal>
        )
    }

    CreateAssetModal = () => {
        return(
            <Modal show={this.state.showCreateModal} onHide={this.handleClose} centered size="lg">
                <Modal.Header closeButton className="bg-gradient-success text-white">
                    <Modal.Title className="d-flex align-items-center">
                        <FaPlus className="me-2" />
                        Tambah Aset Baru
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <CreateAssetForm 
                        handleClose={this.handleClose}
                        createAsset={this.props.createAsset}
                        getAssets={this.props.getAssets}
                    />
                </Modal.Body>
            </Modal>
        )
    }

    editData =(data)=>{
        this.setState({data:data, edit:true, show:true})
    }

    getActiveMonth=()=>{
        const monthNames = ["Januari", "Februari", "Maret", "April", "Mei", "Juni",
            "Juli", "Agustus", "September", "Oktober", "November", "Desember"
          ];
        const active_month = new Date(this.props.books.active_month)
        return "Periode: "+(monthNames[active_month.getUTCMonth()]) +" "+active_month.getUTCFullYear();
    }

    render(){
        if(this.state.done){
            return <Navigate to={"/"} />
        }
        
        return (
            <Container fluid className="my-4 pb-5">
                <this.EditAssetModal/>
                <this.CreateAssetModal/>
                
                {/* Header */}
                <Row className="mb-4">
                    <Col>
                        <Card className="border-0 bg-gradient-primary text-white shadow">
                            <Card.Body className="py-4">
                                <Row className="align-items-center">
                                    <Col md={8}>
                                        <h2 className="mb-2 d-flex align-items-center">
                                            <FaBalanceScale className="me-3" />
                                            Neraca & Analisa Keuangan
                                        </h2>
                                        <div className="d-flex align-items-center flex-wrap gap-3">
                                            <div>
                                                <strong>{this.props.books.name}</strong>
                                                <OverlayTrigger
                                                    placement="bottom"
                                                    overlay={<Tooltip>{this.props.books.desc}</Tooltip>}
                                                >
                                                    <span className="ms-2"><FaInfoCircle size={12} /></span>
                                                </OverlayTrigger>
                                            </div>
                                            <div className="border-start border-white-50 ps-3">
                                                <this.getActiveMonth/>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={4} className="text-end">
                                        <Button 
                                            variant="light" 
                                            className="me-2 d-inline-flex align-items-center"
                                            onClick={() => this.setState({showCreateModal: true})}
                                        >
                                            <FaPlus className="me-2" />
                                            Aset Baru
                                        </Button>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {/* Navigation Tabs */}
                <Row className="mb-4">
                    <Col>
                        <Card className="border-0 shadow-sm">
                            <Card.Body className="py-3">
                                <div className="d-flex gap-3">
                                    <Button
                                        variant={this.state.activeTab === 'neraca' ? 'primary' : 'outline-primary'}
                                        onClick={() => this.setState({activeTab: 'neraca'})}
                                        className="d-flex align-items-center"
                                    >
                                        <FaBalanceScale className="me-2" />
                                        Neraca
                                    </Button>
                                    <Button
                                        variant={this.state.activeTab === 'analisa' ? 'primary' : 'outline-primary'}
                                        onClick={() => this.setState({activeTab: 'analisa'})}
                                        className="d-flex align-items-center"
                                    >
                                        <FaChartBar className="me-2" />
                                        Analisa Keuangan
                                    </Button>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {/* Content */}
                {this.state.activeTab === 'neraca' ? <this.BalanceSheet /> : <this.FinancialAnalysis />}

                {/* Pending Changes Alert */}
                {this.state.dataUpdate.length > 0 && (
                    <Row className="mt-4">
                        <Col>
                            <Alert variant="warning" className="d-flex align-items-center">
                                <FaExclamationTriangle className="me-3 fs-4" />
                                <div className="flex-grow-1">
                                    <strong>Ada {this.state.dataUpdate.length} perubahan yang belum disimpan</strong>
                                    <div className="small">
                                        Perubahan akan disimpan sebagai transaksi ketika Anda menekan "Buka Bulan Baru"
                                    </div>
                                </div>
                                <Badge bg="warning" className="fs-6">
                                    DRAFT
                                </Badge>
                            </Alert>
                        </Col>
                    </Row>
                )}

                {/* Action Buttons */}
                <Row className="mt-4">
                    <Col className="d-flex gap-3 justify-content-between align-items-center">
                        <Button 
                            variant="outline-secondary" 
                            onClick={() => this.setState({done: true})}
                            className="d-flex align-items-center px-4"
                        >
                            <FaTimes className="me-2" />
                            Kembali
                        </Button>
                        
                        <div className="d-flex gap-3 align-items-center">
                            {this.state.dataUpdate.length > 0 && (
                                <Badge bg="warning" className="fs-6 p-2">
                                    {this.state.dataUpdate.length} perubahan menunggu
                                </Badge>
                            )}
                            
                            <Button 
                                variant="danger" 
                                onClick={this.confirmClose}
                                disabled={this.state.saving}
                                className="d-flex align-items-center px-4"
                            >
                                {this.state.saving ? (
                                    <>
                                        <FaSyncAlt className="me-2 spin" />
                                        Memproses...
                                    </>
                                ) : (
                                    <>
                                        <FaSave className="me-2" />
                                        Buka Bulan Baru
                                    </>
                                )}
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    }
}

// Modern Edit Asset Form
class EditAssetForm extends Component{
    constructor(props){
        super(props);
        this.state ={
            data: props.data,
            assetId: props.data.asset_id,
            bookId: JSON.parse(localStorage.bookId),
            name: props.data.name,
            desc: props.data.desc,
            type: props.data.type,
            amount: props.data.finalAmount,
            category: props.data.category,
            amountBefore: props.data.finalAmount,
            tAmount: 0,
            validated: false
        }
    }

    hitungAmount = (value) => {
        const tAmount = value - this.state.amountBefore;
        this.setState({
            amount: value,
            tAmount: tAmount
        });
    }

    saveAsset = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        
        if (form.checkValidity() === false) {
            e.stopPropagation();
            this.setState({ validated: true });
            return;
        }

        if (this.state.tAmount !== 0) {
            this.props.updateAsset({
                assetId: this.state.assetId,
                bookId: this.state.bookId,
                name: this.state.name,
                type: this.state.type,
                category: this.state.category,
                amount: this.state.amount,
                amountBefore: this.state.amountBefore,
                tAmount: this.state.tAmount
            });
        }

        this.props.handleClose();
    }
    deleteAsset = async (e) => {
        this.setState({ 
            showDeleteConfirm: true,
            deleteLoading: false 
        });
    }

    confirmDelete = async () => {
        this.setState({ deleteLoading: true });
        
        try {
            await this.props.deleteAsset(this.state.assetId);
            this.setState({ 
            success: true, 
            showDeleteConfirm: false,
            deleteLoading: false 
            });
            
            setTimeout(() => {
            this.props.handleClose();
            }, 1500);
            
        } catch (error) {
            console.error("Error deleting asset:", error);
            this.setState({ 
            error: "Gagal menghapus data. Silakan coba lagi.", 
            deleteLoading: false,
            showDeleteConfirm: false
            });
        }
    }
    cancelDelete = () => {
        this.setState({ 
            showDeleteConfirm: false,
            deleteLoading: false 
        });
    }   

    render(){
        const difference = this.state.tAmount;
        const differenceColor = difference >= 0 ? 'success' : 'danger';
        const differenceIcon = difference >= 0 ? '↗' : '↘';

        return(
            <Form validated={this.state.validated} onSubmit={this.saveAsset}>
                <ModernConfirmModal
                    show={this.state.showDeleteConfirm}
                    onHide={this.cancelDelete}
                    onConfirm={this.confirmDelete}
                    title="Hapus Aset/Kewajiban"
                    message="Apakah Anda yakin ingin menghapus item ini secara permanent?"
                    itemName={this.state.name}
                    confirmText="Ya, Hapus Permanent"
                    loading={this.state.deleteLoading}
                    stripColor="#dc3545"
                    stripHeight="6px"
                />
                <Row className="g-4">
                    <Col md={6}>
                        <FormGroup>
                            <FormLabel className="fw-bold text-muted">Nama Aset</FormLabel>
                            <div className="p-3 bg-light rounded border">
                                <strong className="text-primary">{this.state.name}</strong>
                            </div>
                        </FormGroup>
                    </Col>
                    
                    <Col md={6}>
                        <FormGroup>
                            <FormLabel className="fw-bold text-muted">Jenis Aset</FormLabel>
                            <div className="p-3 bg-light rounded border">
                                <strong>
                                    {this.state.category === '1' ? 'Aset Lancar' : 
                                     this.state.category === '2' ? 'Aset Tetap' : 'Aset Investasi'}
                                </strong>
                            </div>
                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <FormLabel className="fw-bold text-muted">Nilai Sebelumnya</FormLabel>
                            <div className="p-3 bg-light rounded border">
                                <strong className="text-dark">
                                    {formatValue({
                                        value: this.state.amountBefore.toString(),
                                        intlConfig: { locale: 'id-ID', currency: 'IDR' },
                                    })}
                                </strong>
                            </div>
                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <FormLabel className="fw-bold text-muted">
                                Nilai Baru
                                {difference !== 0 && (
                                    <Badge bg={differenceColor} className="ms-2">
                                        {differenceIcon} {formatValue({
                                            value: Math.abs(difference).toString(),
                                            intlConfig: { locale: 'id-ID', currency: 'IDR' },
                                        })}
                                    </Badge>
                                )}
                            </FormLabel>
                            <CurrencyInput
                                className="form-control form-control-lg border-primary"
                                name="amount"
                                placeholder="Masukkan nilai baru"
                                defaultValue={this.state.amount}
                                decimalsLimit={2}
                                intlConfig= {{locale: 'id-ID', currency: 'IDR'}}
                                onValueChange={(value) => this.hitungAmount(value)}
                                required
                            />
                        </FormGroup>
                    </Col>
                </Row>

                {difference !== 0 && (
                    <Alert variant={differenceColor} className="mt-3">
                        <div className="d-flex align-items-center">
                            <FaInfoCircle className="me-2" />
                            <span>
                                {difference > 0 ? 'Kenaikan' : 'Penurunan'} sebesar {' '}
                                <strong>
                                    {formatValue({
                                        value: Math.abs(difference).toString(),
                                        intlConfig: { locale: 'id-ID', currency: 'IDR' },
                                    })}
                                </strong>
                                {this.state.category === '1' ? ' akan dicatat sebagai transaksi.' : ' hanya akan memperbarui nilai aset.'}
                            </span>
                        </div>
                    </Alert>
                )}

                <div className="d-flex gap-3 justify-content-end pt-4 border-top">
                    <Button 
                        variant="outline-secondary" 
                        onClick={this.props.handleClose}
                        className="px-4"
                    >
                        Batal
                    </Button>
                    {this.state.category != '1' &&
                    <Button
                        variant="danger"
                        onClick={this.deleteAsset}
                        className="action-btn"
                        disabled={this.state.loading}
                    >
                        <FaTrash className="me-2" />
                        Hapus
                    </Button>
                    }
                    <Button 
                        type="submit" 
                        variant="primary"
                        className="px-4 d-flex align-items-center"
                    >
                        <FaSave className="me-2" />
                        Simpan Perubahan
                    </Button>
                </div>
            </Form>
        )
    }
}

// Create Asset Form
class CreateAssetForm extends Component{
    constructor(props){
        super(props);
        this.state ={
            bookId: JSON.parse(localStorage.bookId),
            name: '',
            desc: '',
            type: '1',
            amount: '',
            category: '1',
            validated: false
        }
    }

    saveAsset = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        
        if (form.checkValidity() === false) {
            e.stopPropagation();
            this.setState({ validated: true });
            return;
        }

        this.props.createAsset(this.state).then(() => {
            this.props.handleClose();
            // Refresh assets list
            this.props.getAssets(this.state.bookId);
        });
    }

    render(){
        return(
            <Form validated={this.state.validated} onSubmit={this.saveAsset}>
                <Row className="g-4">
                    <Col md={12}>
                        <FormGroup>
                            <FormLabel className="fw-bold">Nama Aset</FormLabel>
                            <Form.Control
                                type="text"
                                value={this.state.name}
                                onChange={(e) => this.setState({name: e.target.value})}
                                placeholder="Masukkan nama aset"
                                required
                            />
                        </FormGroup>
                    </Col>

                    <Col md={12}>
                        <FormGroup>
                            <FormLabel className="fw-bold">Deskripsi</FormLabel>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                value={this.state.desc}
                                onChange={(e) => this.setState({desc: e.target.value})}
                                placeholder="Deskripsi aset (opsional)"
                            />
                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <FormLabel className="fw-bold">Jenis</FormLabel>
                            <Form.Select
                                value={this.state.type}
                                onChange={(e) => this.setState({type: e.target.value})}
                            >
                                <option value="1">Aset</option>
                                <option value="2">Kewajiban</option>
                            </Form.Select>
                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <FormLabel className="fw-bold">Kategori</FormLabel>
                            <Form.Select
                                value={this.state.category}
                                onChange={(e) => this.setState({category: e.target.value})}
                            >
                                <option value="1">Aset Lancar</option>
                                <option value="2">Aset Guna</option>
                                <option value="3">Aset Investasi</option>
                                <option value="4">Kewajiban Jangka Pendek</option>
                                <option value="5">Kewajiban Jangka Panjang</option>
                            </Form.Select>
                        </FormGroup>
                    </Col>

                    <Col md={12}>
                        <FormGroup>
                            <FormLabel className="fw-bold">Nilai Awal</FormLabel>
                            <CurrencyInput
                                className="form-control"
                                name="amount"
                                placeholder="Masukkan nilai awal"
                                decimalsLimit={2}
                                intlConfig= {{locale: 'id-ID', currency: 'IDR'}}
                                onValueChange={(value) => this.setState({amount: value})}
                                required
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <div className="d-flex gap-3 justify-content-end pt-4 border-top">
                    <Button 
                        variant="outline-secondary" 
                        onClick={this.props.handleClose}
                        className="px-4"
                    >
                        Batal
                    </Button>
                    <Button 
                        type="submit" 
                        variant="success"
                        className="px-4 d-flex align-items-center"
                    >
                        <FaPlus className="me-2" />
                        Tambah Aset
                    </Button>
                </div>
            </Form>
        )
    }
}

// Redux connection
const mapStateToProps = state => ({
    user: state.user,
    books: state.books,
    assets: state.assets,
    categories: state.categories,
    transactions: state.transactions, // Pastikan transactions ada di props
});

const mapDispatchToProps = dispatch => ({
    getUser: (user) => dispatch(getUser(user)),
    getAssets: (book) => dispatch(getAssets(book)),
    createAsset: (book) => dispatch(createAsset(book)),
    updateAsset: (book) => dispatch(updateAsset(book)),
    updateAssets: (book) => dispatch(updateAssets(book)),
    updateBookHistory: (book) => dispatch(updateBookHistory(book)),
    getBook: (book) => dispatch(getBook(book)),
    createTransaction: (book) => dispatch(createTransaction(book)),
    getCategories: (book) => dispatch(getCategories(book)),
    deleteAsset: (book) => dispatch(deleteAsset(book)),
    getTransactions: (book, month, year) => dispatch(getTransactions(book, month, year)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReviewBook);